import { createFileRoute } from '@tanstack/react-router';
import { MeetingSettingsBackground } from '@/pages/settings/MeetingSettingsBackground';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/meeting/background')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['meetings.manageSettings'] }),
	component: MeetingSettingsBackground,
});
